module.exports = __webpack_public_path__ + "img/success.69684ca0.png";